export default __webpack_public_path__ + "static/media/rail-industry.82b2c762.jpg";